import { useNavigate } from "react-router";
import TableColumn from "./columns";
import FilterMenu from "./filter-menu";
import { useEffect, useState } from "react";
import { message, Modal, Table } from "antd";
import SummaryByStatus from "../../../components/summary-status/SummaryByStatus";
import API from "../../../services/api-request";
import { useSearchParams } from "react-router-dom";
import "../../../assets/css/style-table.css";

const RequestInbound = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [summary, setSummary] = useState({});

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOk = () => {
    setOpen(false);
  };

  const queryParams = Object.fromEntries([...searchParams]);
  const pagination = {
    current: parseInt(searchParams.get("page")) || 1,
    pageSize: parseInt(searchParams.get("limit")) || 10,
    total: totalData,
    onChange: (page, limit) => {
      pagination.current = page;
      pagination.pageSize = limit;
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("page", page);
      newSearchParams.set("limit", limit);
      setSearchParams(newSearchParams);
    },
  };

  const getInbound = async (query) => {
    setData([]);
    const queryString = new URLSearchParams(query).toString();
    // Add default page and limit
    if (!searchParams.has("limit")) {
      searchParams.set("limit", 10);
    }
    if (!searchParams.has("page")) {
      searchParams.set("page", 1);
    }
    setSearchParams(searchParams);

    setLoading(true);
    API.Post(`transaction/inbound/list${query ? "?" + queryString : ""}`)
      .then((res) => {
        console.log(res);
        const page = query.page ? parseInt(query.page) - 1 : 0;
        const limit = query.limit ? parseInt(query.limit) : 10;

        setTotalData(res?.data?.data?.totalItems);

        const formatSelect = res?.data?.data?.data?.map((item, index) => {
          return {
            ...item,
            no: page * limit + index + 1,
          };
        });
        console.log("formatSelect", formatSelect);
        setData(formatSelect);
      })
      .catch((err) => {
        setData([]);
        message.info(`${err?.response?.data?.error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getSummary();
    if (queryParams) {
      getInbound(queryParams);
    }
  }, [searchParams]);

  const handleNavigate = (data) => {
    navigate(`/request-inbound/detail/${data.id}`);
  };

  const onDelete = (data) => {
    setSelectedData({ ...data });
    showModal();
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  const getSummary = async () => {
    try {
      const res = await API.Get(`transaction/inbound/summary`);
      console.log(res.data);
      setSummary(res?.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <SummaryByStatus
        waiting_inbound={summary?.pending}
        waiting_outbound={null}
        approve={summary?.approve}
        done={summary?.done}
        reject={summary?.reject}
        total={summary?.total}
      />
      <br />
      <FilterMenu />

      <Table
        style={{ maxWidth: "100%", overflow: "auto" }}
        rowClassName={rowClassName}
        columns={TableColumn(handleNavigate, onDelete)}
        dataSource={data}
        rowKey={(dataSource) => dataSource.id}
        pagination={pagination}
        loading={loading}
      />

      <Modal
        title="Konfirmasi"
        okText="Delete"
        cancelText="Batal"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okType={"primary"}
        okButtonProps={{ danger: true }}
      >
        <p>{`Apakah anda akan menghapus request ini?`}</p>
      </Modal>
    </>
  );
};

export default RequestInbound;
